import { computed, watch } from "vue";
import { useStore } from "vuex";

import { defineStore } from "pinia";

import { AnalyticsService } from "@/lib/analytics/AnalyticsService";
import analyticsProviders from "@/lib/analytics/providers";

import type { IClient } from "@/models/clients";
import type { IUser } from "@/models/users";

export const useAnalyticsStore = defineStore("analytics", () => {
  const { getters } = useStore();
  const analyticsService = new AnalyticsService([
    new analyticsProviders.FullStoryAnalyticsProvider(),
    new analyticsProviders.PostHogAnalyticsProvider(),
  ]);

  const user = computed<IUser | null>(() => {
    return getters["auth/user"];
  });

  const userClientData = computed<IClient | null>(
    () => getters["auth/authClientSettings"]
  );

  watch(user, (value) => {
    const payload = value
      ? {
          id: value.id,
          displayName:
            value.full_name ?? `${value.first_name} ${value.last_name}`,
          email: value.email ?? "",
          roles: value.roles ?? [],
          clientId: value.client_id,
        }
      : null;
    analyticsService.trackUserChange(payload);
  });

  watch(userClientData, (clientData) => {
    const clientDataPayload = {
      clientName: clientData?.name ?? "Client data empty.",
      clientId: clientData?.id ?? "Client data empty.",
    };
    analyticsService.trackUserPropertiesChange(clientDataPayload);
  });

  return { trackEvent: analyticsService.trackEvent.bind(analyticsService) };
});
